export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
};

export const getFileNameFromUrl = (url: string): string => {
  const urlParts = url.split('/');
  const fileName = urlParts[urlParts.length - 1];
  return decodeURIComponent(fileName);
};